<template>
  <v-card class="mx-auto">
    <v-toolbar color="indigo" height="50" dark>
      <v-icon class="mr-3">mdi-account-plus</v-icon>
      <v-toolbar-title class="text-body-1">{{$t('KULLANICILAR.DASHBOARD.NEW_MEMBERS.TITLE')}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-list>
      <v-list-item v-for="(item, key) in newMembers" :key="item.title">
        <v-icon color="primary" size="30">mdi-account</v-icon>
        <v-list-item-content class="ml-3">
          <v-list-item-title v-text="item.title"></v-list-item-title>
          <div class="text-caption">{{item.date}}</div>
        </v-list-item-content>
        <v-list-item-avatar>
          <v-avatar color="blue" size="56">
            <span class="white--text">{{ item.title[0] }}</span>
          </v-avatar>
        </v-list-item-avatar>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
const maleNames = [
  "James", "John", "Robert", "Michael", "William", "David", "Richard", "Joseph", "Charles", "Thomas",
  "Christopher", "Daniel", "Matthew", "Donald", "Anthony", "Paul", "Mark", "George", "Steven", "Kenneth"
];

const femaleNames = [
  "Mary", "Patricia", "Jennifer", "Linda", "Elizabeth", "Barbara", "Susan", "Jessica", "Sarah", "Karen",
  "Nancy", "Lisa", "Betty", "Margaret", "Sandra", "Ashley", "Dorothy", "Emily", "Donna", "Michelle"
];

function getRandomName(names) {
  const randomIndex = Math.floor(Math.random() * names.length);
  return names[randomIndex];
}

function getRandomDate() {
  const start = new Date(2010, 0, 1); // Start date (1st January 2010)
  const end = new Date(); // Current date and time
  const randomDate = new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  return randomDate.toISOString(); // Return date in ISO 8601 format
}

export default {
  name: "NewMembers",

  data() {
    return {
      newMembers: [
        {
          icon: true,
          title: getRandomName(maleNames),
          avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
          date: this.dateFormat(getRandomDate())
        },
        {
          title: getRandomName(maleNames),
          avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
          date: this.dateFormat(getRandomDate())
        },
        {
          title: getRandomName(femaleNames),
          avatar: "https://cdn.vuetifyjs.com/images/lists/3.jpg",
          date: this.dateFormat(getRandomDate())
        },
        {
          title: getRandomName(femaleNames),
          avatar: "https://cdn.vuetifyjs.com/images/lists/4.jpg",
          date: this.dateFormat(getRandomDate())
        }
      ]
    };
  },

  methods: {
    dateFormat(date) {
      return new Intl.DateTimeFormat(this.$store.state.Language.apiLanguage, {
        dateStyle: "long",
        timeStyle: "short"
      }).format(new Date(date));
    },
  }
};
</script>

<style scoped></style>
